module.exports = __webpack_public_path__ + "img/launchpage3.7741b007.jpg";